'use client';
import React, { useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import "./style.css"
import PrefixIconButton from '../buttons/prefixIconButton';
import formatMsg from '../../util/formatMsg';
import colors from '../../libs/colorFactory';
export default function SignatureComponent({ signCanvas, setChange }) {
    const clear = () => {
        setChange(prev => !prev);
        signCanvas.current?.clear();
        // drawPlaceholder();
    };

    const drawPlaceholder = () => {
        const canvas = signCanvas.current?.getCanvas();
        if (canvas) {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height); // Optional: clear previous placeholder if needed
                const text = 'Sign using you finger,stylus, or mouse';
                ctx.font = '16px sans-serif';
                ctx.fillStyle = '#ccc';
                const textWidth = ctx.measureText(text).width;
                const x = (canvas.width - textWidth) / 2;
                const y = canvas.height - 10;
                ctx.fillText(text, x, y);
            }
        }
    };

    useEffect(() => {
        // drawPlaceholder();
    }, []);
    // const handleBegin = () => {
    //     const canvas = sigCanvas.current?.getCanvas();
    //     if (canvas) {
    //         const ctx = canvas.getContext('2d');
    //         if (ctx) {
    //             ctx.clearRect(0, 0, canvas.width, canvas.height);
    //         }
    //     }
    // };

    return (
        <div>
            <div className=" border-gray-400">
                <SignatureCanvas
                    ref={signCanvas}
                    penColor="black"
                    canvasProps={{ width: typeof window != "undefined" && window.innerWidth < 550 ? window.innerWidth - 70 : 550, height: 150, className: 'block' }}
                    onEnd={() => setChange(prev => !prev)}
                />
            </div>
            <div className="mt-2 space-x-2">
                <PrefixIconButton title={formatMsg("clear")}
                    onClick={clear}
                    border={true}
                    borderColor={colors.color_activeColor}
                    fontColor={colors.color_activeColor}
                />
            </div>
        </div>
    );
}
